import {
  INTERMEDIARY_SHAREHOLDER_CITY,
  INTERMEDIARY_SHAREHOLDER_COMPANY_NAME,
  INTERMEDIARY_SHAREHOLDER_COUNTRY,
  INTERMEDIARY_SHAREHOLDER_STATE,
  INTERMEDIARY_SHAREHOLDER_STREET_NAME,
  INTERMEDIARY_SHAREHOLDER_STREET_NUMBER,
  INTERMEDIARY_SHAREHOLDER_VOTING_SHARE,
  INTERMEDIARY_SHAREHOLDER_ZIP_CODE,
} from '@modifi/plugin-onboarding'

export const INTERMEDIARY_SHAREHOLDER_INPUTFIELD_NAMES = [
  INTERMEDIARY_SHAREHOLDER_CITY,
  INTERMEDIARY_SHAREHOLDER_COMPANY_NAME,
  INTERMEDIARY_SHAREHOLDER_COUNTRY,
  INTERMEDIARY_SHAREHOLDER_STATE,
  INTERMEDIARY_SHAREHOLDER_STREET_NAME,
  INTERMEDIARY_SHAREHOLDER_STREET_NUMBER,
  INTERMEDIARY_SHAREHOLDER_VOTING_SHARE,
  INTERMEDIARY_SHAREHOLDER_ZIP_CODE,
]

export const FIELD_NAME_TO_PROPERTY_NAME_MAPPING: Record<string, string> = {}

export type IntermediaryShareholderFormData = {
  [INTERMEDIARY_SHAREHOLDER_CITY]?: string
  [INTERMEDIARY_SHAREHOLDER_COMPANY_NAME]?: string
  [INTERMEDIARY_SHAREHOLDER_COUNTRY]?: string
  [INTERMEDIARY_SHAREHOLDER_STATE]?: string
  [INTERMEDIARY_SHAREHOLDER_STREET_NAME]?: string
  [INTERMEDIARY_SHAREHOLDER_STREET_NUMBER]?: string
  [INTERMEDIARY_SHAREHOLDER_VOTING_SHARE]?: string
  [INTERMEDIARY_SHAREHOLDER_ZIP_CODE]?: string
}
